module.exports = __webpack_public_path__ + "img/chucvu.5ed56b4b.svg";